//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    headers: Array,
    registros: Array,
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/importacao/ImportacaoSucessoTabela.vue?vue&type=script&lang=js&